import { useCurrency } from '@shared/selectors/globalSelectors';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function FlatRate({ data }: { data: any }) {
  const { t } = useTranslation();
  const rateValue = data?.[0]?.rate ?? data?.rate ?? data?.fixed ?? data?.[0]?.fixed ?? t("N/A");
  const unit = data?.[0]?.unit ?? data?.unit ?? t("NA");
  const currency = useCurrency();
  return (
    <div className="flex items-baseline gap-1.5 mt-2">
      <div className="text-lg font-semibold text-slate-900">
        {currency} {rateValue} <span className="text-slate-400 font-normal">/</span>
      </div>
      <div className="text-sm font-medium text-slate-500">{unit}</div>
    </div>
  );
}
